<template functional>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="53.002 -37.6 48.145 32.926"
    style="width: 48px"
  >
    <g transform="translate(53.577 -37.584)">
      <path
        class="a"
        d="M2301.651,5594.953c-.511,3.557-3.656,3.715-5.761,3.6-.148-.008-.3-.035-.43-.049a.164.164,0,0,1-.042-.321,4.833,4.833,0,0,0,2.764-3.745c.048-.5.046-1.193.046-1.328v-9.334h3.481v9.46a13.88,13.88,0,0,1-.058,1.72"
        transform="translate(-2270.591 -5583.529)"
      />
      <path
        class="a"
        d="M2323.958,5763.112c.144-3.648,3.134-6.16,7.76-6.16h12.434c.171,0,.213.109.118.291-.453.862-1.911,3.342-3.717,3.342h-7.237c-4,0-6.675,2.179-7.441,4.419-.139.408-.533,1.381-1.1,1.381-.778,0-.9-1.052-.816-3.273"
        transform="translate(-2296.75 -5741.744)"
      />
      <path
        class="a"
        d="M2023.059,5763.112c-.144-3.648-3.135-6.16-7.761-6.16h-12.433c-.171,0-.214.109-.118.291.452.862,1.912,3.342,3.716,3.342h7.237c4,0,6.675,2.179,7.442,4.419.139.408.532,1.381,1.1,1.381.781,0,.9-1.052.817-3.273"
        transform="translate(-2003.272 -5741.744)"
      />
      <path
        class="a"
        d="M2075.089,5829.965a8.386,8.386,0,0,0,6.312-2.871c1.355-1.858,1.6-5.233,7.669-5.233h5.407s.173.091.093.243c-.457.851-2.095,3.658-3.946,3.658h-2.494c-1.346,0-1.66.923-2.308,2.006a12.4,12.4,0,0,1-21.465,0c-.648-1.083-.961-2.006-2.308-2.006h-2.492c-1.853,0-3.491-2.807-3.946-3.658-.083-.152.089-.243.089-.243h5.408c6.069,0,6.314,3.375,7.67,5.233a8.387,8.387,0,0,0,6.312,2.871"
        transform="translate(-2051.592 -5801.043)"
      />
      <path
        class="a"
        d="M2198.728,5581.487v2.276a9.105,9.105,0,0,0-3.167-.875c-1.359,0-2.387.484-2.387,1.484,0,1.243,2.314,1.829,3.165,2.124s3.367,1.4,3.367,3.654c0,2.389-1.313,4.58-5.866,4.58a8.482,8.482,0,0,1-3.767-.744v-2.251a13.4,13.4,0,0,0,3.489.743c1.56,0,2.5-.336,2.5-1.344,0-1.278-2.444-1.955-3.388-2.344a4.233,4.233,0,0,1-3.111-3.918c0-2.912,2.611-4.1,5.72-4.1a7.865,7.865,0,0,1,3.446.718"
        transform="translate(-2173.989 -5580.785)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'AppLogo'
}
</script>
